export enum FormField {
  CHARTING_DATE = 'chartingDate',
  CHARTING_TIME = 'chartingTime',
  STATE = 'state',
  PATIENT_FULL_NAME = 'patientFullName',
  DECISION_CAPACITY = 'decisionCapacity',
  DECISION_MAKER = 'decisionMaker',
  DECISION_MAKER_NAME = 'decisionMakerName',
  RELATIONSHIP_TO_PATIENT = 'relationshipToPatient',
  PATIENT_CONSENT_CHECKED = 'patientConsentChecked',
  PATIENT_CONSENT_SIGNATURE = 'patientConsentSignature',
  PATIENT_CONSENT_DATE = 'patientConsentDate',
  PATIENT_CONSENT_TIME = 'patientConsentTime',
  PROVIDER_ORDER_CHECKED = 'providerOrderChecked',
  PROVIDER_NAME = 'providerName',
  PROVIDER_TYPE = 'providerType',
  EMERGENCY_PHONE = 'emergencyPhone',
  PROVIDER_SIGNATURE = 'providerSignature',
  PROVIDER_DATE = 'providerDate',
  PROVIDER_TIME = 'providerTime',
  PROVIDER_NURSE = 'providerNurse'
}

export enum FormFieldLabel {
  CHARTING_DATE = 'Charting Date',
  CHARTING_TIME = 'Charting Time',
  STATE = 'State',
  PATIENT_FULL_NAME = "Patient's Full Name",
  DECISION_CAPACITY = 'Does the patient have decision making capacity?',
  DECISION_MAKER = 'Decision Maker',
  DECISION_MAKER_NAME = 'Name',
  RELATIONSHIP_TO_PATIENT = 'Relationship to Patient',
  PATIENT_CONSENT_SIGNATURE = 'Signature',
  PATIENT_CONSENT_DATE = 'Date',
  PATIENT_CONSENT_TIME = 'Time',
  PROVIDER_NAME = 'Name',
  PROVIDER_TYPE = 'Provider Type',
  EMERGENCY_PHONE = 'Emergency Phone',
  PROVIDER_SIGNATURE = 'Signature',
  PROVIDER_DATE = 'Date',
  PROVIDER_TIME = 'Time',
  PROVIDER_NURSE = 'Provider / Nurse'
}

export enum DecisionCapacityValue {
  YES = 'yes',
  NO = 'no'
}

export enum SectionTitle {
  DO_NOT_RESUSCITATE = 'Do Not Resuscitate',
  GENERAL_INFORMATION = 'General Information',
  PATIENT_CONSENT = "Patient's Consent",
  PROVIDER_ORDER = 'Provider Order'
}

export const DNR_NOTICE =
  'This order applies only to resuscitation (CPR). All other appropriate treatments and comfort care will continue. Consult with your state\u2019s specific guidelines for more specific information.';

export const DECISION_MAKER_HINT = 'Definitions based on applicable state law';

// Fields that should never be required for save enablement (auto-filled / optional attestation).
export const NON_REQUIRED_FIELDS: string[] = [
  FormField.CHARTING_DATE,
  FormField.CHARTING_TIME,
  FormField.PROVIDER_NURSE,
  FormField.DECISION_CAPACITY,
  FormField.PATIENT_CONSENT_CHECKED
];

// Required only when the patient does NOT have decision making capacity (progressive disclosure).
export const REQUIRED_DECISION_MAKER_FIELDS: FormField[] = [FormField.DECISION_MAKER, FormField.DECISION_MAKER_NAME, FormField.RELATIONSHIP_TO_PATIENT];

// Required only when the patient HAS decision making capacity (the patient signs the consent).
export const PATIENT_CONSENT_SIGNATURE_FIELDS: FormField[] = [FormField.PATIENT_CONSENT_SIGNATURE];
